import { Controller } from "react-hook-form";
import CustomSelect from "../../CustomSelect";
import "./style.css";

interface IProps {
  name: string;
  control: any;
  options: { label: string; value: string }[];
  className?: string;
  containerClassName?: string;
  label: string;
  showClear?: boolean;
  showSearch?: boolean;
  error?: string;
  disabled?: boolean;
  loading?: boolean;
  onCustomChange?: (val?: string) => void;
}

const ControlledSelect = ({
  name,
  control,
  options,
  className = "",
  containerClassName = "",
  label,
  showClear,
  showSearch,
  error,
  disabled,
  loading,
  onCustomChange,
}: IProps) => {
  return (
    <div className={`controlled-select-container ${containerClassName || ""}`}>
      <label htmlFor={name} className={`controlled-select-label ${error ? "error" : ""}`}>
        {label}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <CustomSelect
            value={value}
            onChange={onChange}
            options={options}
            showClear={showClear}
            showSearch={showSearch}
            className={`controlled-select-input ${className || ""} ${error ? "error" : ""}`}
            disabled={disabled || loading}
          />
        )}
      />
      {error && <small className="controlled-select-error">{error}</small>}
    </div>
  );
};

export default ControlledSelect;
